import React, { forwardRef, useEffect } from 'react';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Typography, Grid } from '@mui/material';
import { Arrow } from 'state/providers/EditTeachingOrderProvider/types';

export const EditTeachingOrderGridCard = forwardRef(
  ({ item, index, style, ...props }: any, ref) => {
    const inlineStyles = {
      height: 150,
      width: 300,
      margin: 10,
      borderRadius: '4px',
      backgroundColor: 'white',
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
      ...style,
    };

    let followCardOnScreenTimeout;
    const cardText = `${item?.toUpperCase()}${item?.toLowerCase()}`;

    const scrollCardIntoView = (id: string) => {
      followCardOnScreenTimeout = setTimeout(() => {
        document
          .getElementById(id)
          ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      });
    };

    const handleOnClick = (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      direction: Arrow,
      index: any
    ) => {
      scrollCardIntoView(cardText);
      props.handleCardChange(event, direction, index);
    };

    const preventDragOnButton = (event: React.MouseEvent | React.PointerEvent) => {
      event.stopPropagation();
    };

    useEffect(() => {
      clearTimeout(followCardOnScreenTimeout);
    }, []);

    return (
      <Grid container item spacing={1} xs={4} md={3} lg={2} xl={2}>
        <div ref={ref} style={inlineStyles} {...props} id={cardText}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            margin="5px 10px"
          >
            <Box margin="15px">
              <Typography variant="h5"> {cardText}</Typography>
            </Box>
            <Box>
              <Button
                disabled={index === 0}
                onMouseDown={preventDragOnButton}
                onPointerDown={preventDragOnButton}
                onClick={(event) => handleOnClick(event, Arrow.left, index)}
              >
                <FontAwesomeIcon
                  size="2x"
                  icon={faArrowLeft}
                  {...(index !== 0 ? { color: 'black' } : {})}
                />
              </Button>
              <Button
                id={index}
                disabled={index === props.arrayLength - 2}
                onMouseDown={preventDragOnButton}
                onPointerDown={preventDragOnButton}
                onClick={(event) => handleOnClick(event, Arrow.right, index)}
              >
                <FontAwesomeIcon
                  size="2x"
                  icon={faArrowRight}
                  {...(index !== props.arrayLength - 2 ? { color: 'black' } : {})}
                />
              </Button>
            </Box>
          </Box>
        </div>
      </Grid>
    );
  }
);
